import 'babel-polyfill';
import Vue from 'vue'
import Vuex from 'vuex';
import navIndex from './modules/nav-index.js'
import lang from './modules/lang';
import animated from './modules/animated';
import newList from './modules/new-list.js';
import jobsList from './modules/jobs.js';
import middleNavFixed from './modules/mid-nav-fixed';
import showQRCode from './modules/QRCode.js';




Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    navIndex,
    lang,
    animated,
    newList,
    jobsList,
    middleNavFixed,
    showQRCode
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js